import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { CompanySettingsDocument } from './graphql/companySettings.gql';

export const useCompanySettingsQuery = () => {
  const { companyProfileId } = useCompanyContext();

  const { data, ...hook } = useQuery(CompanySettingsDocument, {
    fetchPolicy: 'cache-and-network',
    skip: !companyProfileId,
    variables: {
      companyProfileId: companyProfileId as string,
    },
  });

  return {
    companyMetadata: data?.viewer.company.metadata,
    companySettings: data?.viewer.company.settings,
    ...hook,
  };
};

export type CompanySettings = NonNullable<
  NonNullable<
    Awaited<ReturnType<typeof useCompanySettingsQuery>>
  >['companySettings']
>;
